import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function LittleAngels() {
  return (
    <section className='giving ptb-50'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='sec-heading'>
              <h2>OUR LITTLE ANGELS</h2>
            </div>
          </div>
        </div>
        <div className='main-giving'>
          <div className='row items-center'>
            <div className='col-md-4 mx-auto'>
              <div className='little-angel-card'>
                <div className='angel-card-inside-box'>
                  <div className='angel-card-featured-img'>
                    <img src='/assets/images/hamda.png' alt='' />
                  </div>
                  <div className='angel-card-content'>
                    <div className='footer-flex'>
                      <Link to='/our-little-angels'>
                        <div className='little-angel-title'>Hamda</div>
                      </Link>
                      <div className='little-angel-age'>2 Years</div>
                    </div>
                    <div className='little-angel-disease'>
                      <p>Blood Cancer</p>
                    </div>
                    <div className='little-angel-heading'>
                      <p>
                        <strong>In Loving Memory of Hamda</strong>
                      </p>
                    </div>
                    <div className='little-angel-short_desc'>
                      <p>
                        It is with profound sorrow that we share the news of
                        Hamda's passing. Hamda was a beacon of hope and
                        resilience, inspiring everyone around him with his
                        courage and unwavering spirit. His journey touched the
                        hearts of many, and his legacy will continue to inspire
                        us all.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-6 align-center little-angel-pt-24'>
              <div className='logo-image'>
                <img src='assets/images/logo.png' />
                <h2>A Tribute to our Brave Souls.</h2>
              </div>

              <div className='little-angels-para pt-2'>
                <p>
                  In the memory of our brave souls who fought till the last
                  breath. Kids, you will always be in our hearts. We hope you
                  are in a better place. We will forever cherish the moment
                  spent together. Adios.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LittleAngels;
